import React, { FC } from 'react';
import { Formats, setClass } from '@utils';
import { isMobile } from 'react-device-detect';
import { Button } from '@components';
import '../../../../../styles/components/formatBlock.scss';

interface FormatBlockProp {
  format: string;
  onUpdateFormat: (value: string) => void;
  isEdit: boolean;
}

export const FormatBlock: FC<FormatBlockProp> = ({
  format, onUpdateFormat, isEdit
}) => {

  return (
    <div className="area format">
      {isEdit 
        ? (
          <div className={setClass(isMobile && 'mobile-format-buttons')}>
            <Button
              title="Online встреча"
              className={setClass('format-button', format === Formats.OFFLINE && 'unpressed', isMobile && 'mobile')}
              onClick={() => onUpdateFormat(Formats.ONLINE)}
            />
            <Button
              title="Offline встреча"
              className={setClass('format-button', format === Formats.ONLINE && 'unpressed', isMobile && 'mobile')}
              onClick={() => onUpdateFormat(Formats.OFFLINE)}
            />
          </div>
        )
        : (
          <div className='format-button view-format-block'>
            {format === Formats.ONLINE ? 'Online встреча' : 'Offline встреча'}
          </div>
        )
      }
    </div>
  );
};
